import belt from './img/belt.jpg';
import wallet from './img/wallet.jpg'
import tableware from './img/table.jpg'

export const Trend = [
  {
    id: 1,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/TG-Classic-Belt-Cognac-Stainless-Thumb_1800x1800.jpg?v=1648151092",
    title: "Classic Belt - Cognac",
    type: "TANNER GOODS",
    price: "$115.00",
  },
  {
    id: 2,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/TG_Product_DailyBelt_BlackSilver_Resize_071520-THUMB_1800x1800.jpg?v=1595889972",
    title: "Daily Belt - Black",
    type: "TANNER GOODS",
    price: "$115.00",
  },
  {
    id: 3,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/Mazama-Standard-Mug-Sandstone_1800x1800.jpg?v=1650000370",
    title: "Standard Mug",
    type: "MAZAMA",
    price: "$36.00",
  },
  {
    id: 4,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/Canyon-Crossbody-Green-Konbu-Front_1800x1800.jpg?v=1631897400",
    title: "Canyon Crossbody Pack - Olive Konvu",
    type: "TANNER GOODS",
    price: "$125.00",
  },
  {
    id: 5,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/bifold_cognac_2015_thumb_01_d0c96c99-25be-4bae-9eab-297be4d54904_1800x1800.jpg?v=1603228378",
    title: "Utility Bifold - Cognac",
    type: "TANNER GOODS",
    price: "$125.00",
  },
];


export const type_images= [
  {
    id:6,
    images:belt,
    titles:"Belts",
  },
  {
    id:7,
    images:wallet,
    titles:"Wallets",
  },
  {
    id:8,
    images:tableware,
    titles:"TableWare",
  },
]


export const Sell = [
  {
    id: 9,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/TG-Classic-Belt-Cognac-Stainless-Thumb_1800x1800.jpg?v=1648151092",
    title: "Classic Belt - Cognac",
    type: "TANNER GOODS",
    price: "$115.00",
  },
  {
    id: 10,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/TG_Product_DailyBelt_BlackSilver_Resize_071520-THUMB_1800x1800.jpg?v=1595889972",
    title: "Daily Belt - Black",
    type: "TANNER GOODS",
    price: "$115.00",
  },
  {
    id: 11,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/Mazama-Standard-Mug-Sandstone_1800x1800.jpg?v=1650000370",
    title: "Standard Mug",
    type: "MAZAMA",
    price: "$36.00",
  },
  {
    id: 12,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/Canyon-Crossbody-Green-Konbu-Front_1800x1800.jpg?v=1631897400",
    title: "Canyon Crossbody Pack - Olive Konvu",
    type: "TANNER GOODS",
    price: "$125.00",
  },

];

export const Sells = [

  {
    id: 13,
    image:
      "https://cdn.shopify.com/s/files/1/0044/9802/products/bifold_cognac_2015_thumb_01_d0c96c99-25be-4bae-9eab-297be4d54904_1800x1800.jpg?v=1603228378",
    title: "Utility Bifold - Cognac",
    type: "TANNER GOODS",
    price: "$125.00",
  },
  {
    id:14,
    image:"https://cdn.shopify.com/s/files/1/0044/9802/products/journeyman_natural_2020_thumb_01_1800x1800.jpg?v=1629492883",
    title:"Journeyman - Natural",
    type:"TANNER GOODS",
    price:"$85.00",
  },
  {
    id:15,
    image:"https://cdn.shopify.com/s/files/1/0044/9802/products/bifold_cognac_2015_thumb_01_d0c96c99-25be-4bae-9eab-297be4d54904_1800x1800.jpg?v=1603228378",
    title:"Utility Bifold - Cognac",
    type:"TANNER GOODS",
    price:"$125.00",
  },
  {
    id:16,
    image:"https://cdn.shopify.com/s/files/1/0044/9802/products/Mazama-Crater-Lake-Mug-Sandstone_360x.jpg?v=1650000939",
    title:"Crater Lake Mug",
    type:"MAZAMA",
    price:"$38.00",
  },
] 

